import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Carousel, CarouselVariant, IconSize, SliderNavColor, SliderNavVariant, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { MapPinFillIcon } from '@yonderland/andes-icons';
import { Box, Button, Stack, TextAlpha } from '@yonderland/andes-react';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_TABLET_SMALL, MAX_SCREEN_WIDTH_MOBILE, MIN_SCREEN_WIDTH_MOBILE, } from '../../constants/ScreenWidthConstants';
import { SLIDE_SPACING } from '../../constants/SliderConstants';
import { getPictureSrcset } from '../../util/ImageUtil';
import { StoreActualInfoTag } from './StoreActualInfoTag';
import { StoreAddress } from './StoreAddress';
import { StoreInfoTag } from './StoreInfoTag';
export const OpenedStores = ({ openedStores, copy }) => {
    const { root, imageCdnPrefix } = useAemConfig();
    if (!openedStores || openedStores.length === 0) {
        return null;
    }
    const carouselProps = {
        variant: CarouselVariant.STORES,
        arrowsConfig: {
            variant: SliderNavVariant.CIRCLE,
            color: SliderNavColor.BASE,
            iconSize: IconSize.MINOR,
        },
        configurationOverrides: {
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            shouldSwiperUpdate: true,
            breakpoints: {
                [MIN_SCREEN_WIDTH_MOBILE]: {
                    spaceBetween: SLIDE_SPACING.MOBILE,
                    slidesPerView: openedStores.length > 1 ? 1.1 : 1,
                },
                [MAX_SCREEN_WIDTH_MOBILE]: {
                    spaceBetween: SLIDE_SPACING.MOBILE,
                    slidesPerView: openedStores.length > 1 ? 1.5 : 1,
                },
                [MIN_SCREEN_WIDTH_TABLET_SMALL]: {
                    spaceBetween: SLIDE_SPACING.MOBILE,
                    slidesPerView: openedStores.length > 2 ? 2.5 : 2,
                },
                [MIN_SCREEN_WIDTH_TABLET]: {
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                    slidesPerView: openedStores.length > 3 ? 3.2 : 3,
                },
                1100: {
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                    slidesPerView: openedStores.length > 4 ? 4.2 : 4,
                },
            },
        },
    };
    const handleClick = (store) => () => (window.location.href = `${root}${store.relativeStorePagePath}.html`);
    return (_jsx(Box, { paddingBlock: { base: '3', lg: '5' }, children: _jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingXL", children: copy.title }), _jsx(Carousel, Object.assign({}, carouselProps, { children: openedStores.map(store => (_jsx("div", { style: { height: 'auto' }, children: _jsxs(Card, { onClick: handleClick(store), fullWidth: true, children: [store.image && (_jsx(Card.Media, { src: store.image.imagePath, srcset: getPictureSrcset(store.image, imageCdnPrefix), alt: store.storeName, isPicture: true })), _jsx(Card.Header, { title: store.storeName }), _jsx(Card.Body, { children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(StoreActualInfoTag, { scheduleEntries: store.scheduleEntries }), _jsx(StoreInfoTag, { icon: MapPinFillIcon, children: _jsx(TextAlpha, { as: "span", children: _jsx(StoreAddress, { address: store.address }) }) })] }) }), _jsx(Card.Footer, { children: _jsx(Button, { variant: "secondary", fullWidth: true, children: copy.button }) })] }) }, store.code))) }))] }) }));
};
